import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { queryMultiTransactionSuccess, queryMultiTransactionFailure } from '../actions';
import transactionHistoryTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';


const { API_BASE_URL } = urls || {};

function* queryMultiTransaction({ payload }) {
  const { startFrom, cb } = payload;
  const url = `${API_BASE_URL}/payments/requery`;

  const response = yield request({
    method: 'post',
    data: startFrom
      ? {
          startingFrom: startFrom,
        }
      : {},
    url,
  });

  if (response.success) {
    yield put(queryMultiTransactionSuccess());
    cb(response.raw);
  } else {
    yield put(
      queryMultiTransactionFailure(
        'An error occured. Please reload the page to try again.'
      )
    );
    networkErrorHandler(response?.statusCode, response.maessage || 'An error occured. Please reload the page to try again.');
  }
}

export function* onQueryMultiTransaction() {
  yield takeLatest(
    transactionHistoryTypes.QUERY_MULTIPLE_TRANSACTIONS_START,
    queryMultiTransaction
  );
}
